var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.1665 11.4668C59.7332 15.7334 63.3332 22.4334 63.3332 30.0001C63.3332 34.8334 61.8998 39.2668 59.4332 42.9668C55.8332 48.3001 50.1332 52.0668 43.4998 53.0334C42.3665 53.2334 41.1998 53.3334 39.9998 53.3334C38.7998 53.3334 37.6332 53.2334 36.4998 53.0334C29.8665 52.0668 24.1665 48.3001 20.5665 42.9668C18.0998 39.2668 16.6665 34.8334 16.6665 30.0001C16.6665 17.1001 27.0998 6.66675 39.9998 6.66675",
    stroke: "#2DD06E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8334 61.5667L65.3334 62.8666C64.1001 63.1666 63.1334 64.1 62.8668 65.3334L61.7001 70.2334C61.0668 72.9 57.6668 73.7001 55.9001 71.6001L40.0001 53.3334L24.1001 71.6333C22.3334 73.7333 18.9334 72.9333 18.3001 70.2666L17.1334 65.3666C16.8334 64.1333 15.8668 63.1667 14.6668 62.9L9.16677 61.6001C6.63343 61.0001 5.73343 57.8333 7.56677 56L20.5668 43C24.1668 48.3333 29.8668 52.1001 36.5001 53.0667C37.6334 53.2667 38.8001 53.3667 40.0001 53.3667C41.2001 53.3667 42.3668 53.2667 43.5001 53.0667C50.1334 52.1001 55.8334 48.3333 59.4334 43L72.4334 56C74.2668 57.8 73.3668 60.9667 70.8334 61.5667Z",
    stroke: "#2DD06E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9336 19.9333L43.9002 23.8666C44.1669 24.3999 44.8669 24.9332 45.5002 25.0332L49.0669 25.6332C51.3336 25.9999 51.8669 27.6666 50.2336 29.2999L47.4669 32.0665C47.0002 32.5332 46.7336 33.4333 46.9002 34.0999L47.7002 37.5332C48.3336 40.2332 46.9002 41.2999 44.5002 39.8665L41.1669 37.8999C40.5669 37.5332 39.5669 37.5332 38.9669 37.8999L35.6336 39.8665C33.2336 41.2665 31.8002 40.2332 32.4336 37.5332L33.2336 34.0999C33.3669 33.4666 33.1336 32.5332 32.6669 32.0665L29.9002 29.2999C28.2669 27.6666 28.8002 26.0332 31.0669 25.6332L34.6336 25.0332C35.2336 24.9332 35.9336 24.3999 36.2002 23.8666L38.1669 19.9333C39.1336 17.7999 40.8669 17.7999 41.9336 19.9333Z",
    stroke: "#2DD06E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.0cd169bec184adb170e9820b1a7e464d.svg";
export { ForwardRef as ReactComponent };